import { render, staticRenderFns } from "./ShortcutIcon.vue?vue&type=template&id=0a4c1ca6&scoped=true"
import script from "./ShortcutIcon.vue?vue&type=script&lang=js"
export * from "./ShortcutIcon.vue?vue&type=script&lang=js"
import style0 from "./ShortcutIcon.vue?vue&type=style&index=0&id=0a4c1ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c1ca6",
  null
  
)

export default component.exports